import React from 'react';
import Image from 'react-bootstrap/Image';
import Poster from '../images/poster.png'

export default function Home() {
  return <Image src={Poster} style={{width: "100%"}} alt='wedding' fluid />;
}